// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-P3I","colBig":"styles_colBig__jTP0O","colSmall":"styles_colSmall__3zgt6","shopifyNameWrapper":"styles_shopifyNameWrapper__HwsmL"};